import bodymovin from 'lottie-web';

window.addEventListener('DOMContentLoaded', () => {
  /* eslint-disable-next-line */
    const animation = bodymovin.loadAnimation({
    container: document.getElementsByClassName('hero-homepage__video')[0],
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: '/app/themes/turn-the-tables/images/JSON Video/TTT MAIN/TTT_MAIN.json'
  });
});
